import styled from 'styled-components';

export const Container = styled.div`
  font-family: var(--main-font);
  align-items: center;
  width: 100%;
  display: flex;
  flex-flow: column wrap;
  
`;
